import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { InsectaServiceBase } from './insecta.base.service';

@Injectable({
  providedIn: 'root'
})
export class UploadService extends InsectaServiceBase {
  public getImage(id: string, download = false): Observable<string> {
    return this.httpClient
      .get(`${this.baseUrl}v1/uploads/${id}?download=${download}`, { responseType: 'blob' })
      .pipe(map((blob) => URL.createObjectURL(blob)));
  }

  public uploadImage(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.postFormData<string>(`/uploads`, 'v1', formData);
  }
}
